import React from "react";
import { toast } from "react-toastify";
import Layout4 from "../../components/Layout/Layout4";
import Loading from "../../components/Loading";
import Table from "../../components/Table";
import { completeOrder, getOthersStaffOrder } from "../../utils/api";
import { formatDate } from "../../utils/formatData";
import useStore from "../../utils/store";

const OtherStaff = () => {
  const [dash, setDash] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const user = useStore((state) => state.user);
  const getData = async () => {
    setLoading(true);
    const [success, data] = await getOthersStaffOrder();
    if (success) {
      setDash(data);
    }
    setLoading(false);
  };
  React.useEffect(() => {
    getData();
  }, []);
  return (
    <Layout4 type={"OtherStaff"} title={user?.staff?.userName}>
      {loading && <Loading />}
      <Table
        type={"otherStaff"}
        data={dash}
        columns={[
          {
            title: "Date",
            render: (row) => formatDate(row?.createdAt),
          },
          {
            title: "Customer",
            render: (row) => row.customer.userName,
          },
          {
            title: "description",
            render: (row) => row.description,
          },
          {
            title: "Location",
            render: (record) => record?.customer?.group?.name,
          },
          {
            title: "Items",
            render: (row) => row.product.productName,
          },
          {
            title: "FSSAI",
            render: (record) => record?.customer?.fssai,
          },
          {
            title: "Agency",
            render: (record) => record?.customer?.agency,
          },
          {
            title: "Qnt.",
            render: (row) => row.quantity,
          },
          {
            title: "PDF",
            render: (row) => (
              <button
                className="bg-green-500  px-2 py-1 "
                onClick={async () => {
                  setLoading(true);
                  const [success, data] = await completeOrder(row._id, {
                    type: "staff",
                    completedById: user.staff._id,
                  });
                  if (success) {
                    toast.success("Order Completed");
                    getData();
                  } else {
                    toast.error(data);
                  }
                  setLoading(false);
                }}
              >
                Complete
              </button>
            ),
          },
        ]}
      />
    </Layout4>
  );
};

export default OtherStaff;
